module.exports = __webpack_public_path__ + "img/fi-rr-time-forward-ten.7dfc032f.svg";